module.exports = __webpack_public_path__ + "static/media/Badge_CuirChevelu.e05bc36f.png";